// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiDenial {
    static getAttributeTypeMap() {
        return MedicalBiDenial.attributeTypeMap;
    }
}
MedicalBiDenial.discriminator = undefined;
MedicalBiDenial.additionalProperties = false;
MedicalBiDenial.attributeTypeMap = [
    {
        "name": "date",
        "baseName": "date",
        "type": "Date"
    },
    {
        "name": "number",
        "baseName": "number",
        "type": "string"
    },
    {
        "name": "reason",
        "baseName": "reason",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiDenial.js.map